import { store } from '@redux/store';
import { debounceTime, fromEvent, map, merge, of, switchMap } from "rxjs";
import { selectPage, articleSearchResultsActions } from 'features/articleSearchResultsFacets';

const getLinkAbleElement = (event) => event.target.closest('[data-page-link]');
const paginationContainer = document.querySelector('[data-component="blog-article-search-results-pagination"]');
const previousButton = paginationContainer.querySelector('[data-prev-button]');
const nextButton = paginationContainer.querySelector('[data-next-button]');
const optionList = paginationContainer.querySelector('[data-option-list]');

// observable to emmit the new page after prev button click event
const previousButton$ = fromEvent(previousButton, 'click').pipe(
    map(() => selectPage(store.getState())),
    map((currentPage) => currentPage -1)
);

// observable to emmit the new page after next button click event
const nextButton$ = fromEvent(nextButton, 'click').pipe(
    map(() => selectPage(store.getState())),
    map((currentPage) => currentPage +1)
);

// observable to emmit the new page after option button click event
const optionList$ = fromEvent(optionList, 'click').pipe(
    switchMap((event) => {
        const linkableElement = getLinkAbleElement(event);
        if(linkableElement) {
            event.preventDefault();
        }

        const page = Number(linkableElement?.dataset?.pageLink || 0);
        return of(page);
    })
);

// debounceTime to allow log events before to change the store current page
const pageChange$ = merge(previousButton$, nextButton$, optionList$).pipe(debounceTime(100));

// function to update the page number
const updatePageNumber = function(newPageNumber){
  store.dispatch(articleSearchResultsActions.updatePageParameter(newPageNumber));
};

pageChange$.subscribe(updatePageNumber);

